module.exports = __webpack_public_path__ + "static/media/8.question.05be0809.mp4";